import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import settingsReducer from '../features/settings/settingsSlice';
import loadingReducer from '../features/loading/loadingSlice';
import { logout } from '../features/auth/authSlice';
import techniquesReducer from '../features/techniques/techniquesSlice';
import notesReducer from '../features/notes/notesSlice';
import schedulesReducer from '../features/schedules/schedulesSlice';
import fitnessReducer from '../features/fitness/fitnessSlice';
import usersReducer from '../features/users/usersSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    settings: settingsReducer,
    loading: loadingReducer,
    techniques: techniquesReducer,
    notes: notesReducer,
    schedules: schedulesReducer,
    fitness: fitnessReducer,
    users: usersReducer,
    notifications: notificationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Debug: Log state changes
// store.subscribe(() => {
//   console.log('Current state:', store.getState());
// });

// Middleware to handle API errors
export const apiErrorMiddleware = (store) => (next) => (action) => {
  if (action.type.endsWith('/rejected')) {
    // Handle 401 Unauthorized
    if (action.payload === 'Token is invalid or expired') {
      store.dispatch(logout());
    }
  }
  return next(action);
};

// Middleware to handle token refresh
export const tokenMiddleware = (store) => (next) => (action) => {
  if (action.type.endsWith('/fulfilled') && action.payload?.access) {
    localStorage.setItem('token', action.payload.access);
  }
  return next(action);
};

export default store;